import React from 'react'

export default function EyeIco() {
  return (
    <svg
      width="20"
      height="13"
      viewBox="0 0 20 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0007 10.333C11.0423 10.333 11.9279 9.96856 12.6573 9.23967C13.3862 8.51023 13.7507 7.62467 13.7507 6.58301C13.7507 5.54134 13.3862 4.65579 12.6573 3.92634C11.9279 3.19745 11.0423 2.83301 10.0007 2.83301C8.95898 2.83301 8.07343 3.19745 7.34399 3.92634C6.6151 4.65579 6.25065 5.54134 6.25065 6.58301C6.25065 7.62467 6.6151 8.51023 7.34399 9.23967C8.07343 9.96856 8.95898 10.333 10.0007 10.333ZM10.0007 8.83301C9.37565 8.83301 8.84454 8.61412 8.40732 8.17634C7.96954 7.73912 7.75065 7.20801 7.75065 6.58301C7.75065 5.95801 7.96954 5.42662 8.40732 4.98884C8.84454 4.55162 9.37565 4.33301 10.0007 4.33301C10.6257 4.33301 11.157 4.55162 11.5948 4.98884C12.032 5.42662 12.2507 5.95801 12.2507 6.58301C12.2507 7.20801 12.032 7.73912 11.5948 8.17634C11.157 8.61412 10.6257 8.83301 10.0007 8.83301ZM10.0007 12.833C7.97287 12.833 6.12565 12.2669 4.45898 11.1347C2.79232 10.003 1.58398 8.48579 0.833984 6.58301C1.58398 4.68023 2.79232 3.16273 4.45898 2.03051C6.12565 0.898841 7.97287 0.333008 10.0007 0.333008C12.0284 0.333008 13.8757 0.898841 15.5423 2.03051C17.209 3.16273 18.4173 4.68023 19.1673 6.58301C18.4173 8.48579 17.209 10.003 15.5423 11.1347C13.8757 12.2669 12.0284 12.833 10.0007 12.833Z"
        fill="#6B7280"
      />
    </svg>
  )
}
